import apiService from './apiService';

// Queue endpoints are server-paged and server-filtered; omit empty filters so the
// backend treats them as "no filter" rather than matching on an empty string.
const buildQueueParams = ({ page = 0, size = 25, companyId, search } = {}) => ({
    page,
    size,
    ...(companyId ? { companyId } : {}),
    ...(search ? { search } : {})
});

export const kycService = {
    kycRequirements: {
        create: (data) => apiService.post('/kyc-requirements', data),
        getAll: () => apiService.get('/kyc-requirements'),
        getById: (id) => apiService.get(`/kyc-requirements/${id}`),
        getByCompany: (companyId) => apiService.get(`/kyc-requirements/company/${companyId}`),
        getByCompanyAndClientType: (companyId, clientType) =>
            apiService.get(`/kyc-requirements/company/${companyId}/client-type/${clientType}`),
        getMandatoryByCompanyAndClientType: (companyId, clientType) =>
            apiService.get(`/kyc-requirements/company/${companyId}/client-type/${clientType}/mandatory`),
        update: (id, data) => apiService.put(`/kyc-requirements/${id}`, data),
        delete: (id) => apiService.delete(`/kyc-requirements/${id}`)
    },

    clientKyc: {
        submitWithFile: async (clientId, kycRequirementId, file, documentNumber, notes) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('clientId', clientId);
            formData.append('kycRequirementId', kycRequirementId);
            if (documentNumber) formData.append('documentNumber', documentNumber);
            if (notes) formData.append('notes', notes);

            const token = localStorage.getItem('nexus_token');
            const response = await fetch(
                `${apiService.baseURL}/client-kyc/submit`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': token ? `Bearer ${token}` : ''
                    },
                    body: formData
                }
            );

            return await apiService.handleResponse(response);
        },
        submit: (data) => apiService.post('/client-kyc/submit', data),
        verify: (id) => apiService.patch(`/client-kyc/${id}/verify`),
        approve: (id) => apiService.put(`/client-kyc/${id}/approve`),
        reject: (id, reasonCode, comment) => apiService.put(`/client-kyc/${id}/reject`, { reasonCode, comment }),
        getByClient: (clientId) => apiService.get(`/client-kyc/client/${clientId}`),
        getByClientAndCompany: (clientId, companyId) => apiService.get(`/client-kyc/client/${clientId}/company/${companyId}`),
        getPending: (params = {}) => apiService.get('/client-kyc/pending', buildQueueParams(params)),
        getPendingApproval: (params = {}) => apiService.get('/client-kyc/pending-approval', buildQueueParams(params)),
        getQueueCounts: ({ companyId, search } = {}) => apiService.get('/client-kyc/queue-counts', {
            ...(companyId ? { companyId } : {}),
            ...(search ? { search } : {})
        }),
        getRejectionReasons: () => apiService.get('/client-kyc/rejection-reasons'),
        getChecklist: (clientId, companyId) => apiService.get(`/client-kyc/client/${clientId}/company/${companyId}/checklist`),
        checkComplete: (clientId, companyId) => apiService.get(`/client-kyc/client/${clientId}/company/${companyId}/complete`),
        getById: (id) => apiService.get(`/client-kyc/${id}`),
        getHistory: (kycId) => apiService.get(`/client-kyc/${kycId}/history`),
        getDocuments: (clientId) => apiService.get(`/client-kyc/client/${clientId}/documents`),
        delete: (id) => apiService.delete(`/client-kyc/${id}`)
    }
};
